import React from 'react';
import {ErrorModal} from '@igp/shared/components/error';
import {withTraceErrorBoundary} from '@igp/shared/otel';

import {withAccessCheck} from '@access-control';

import {playerLevelReportAllResource} from './permissions';
import {PlayerLevelReportBase} from './PlayerLevelReportBase';

function PlayerLevelReportAllInner() {
    return <PlayerLevelReportBase tab="all" columnsSettingsViewType="PlayerLevelReportAll" />;
}

const PlayerLevelReportAllWithAccess = withAccessCheck(PlayerLevelReportAllInner, playerLevelReportAllResource);

export const PlayerLevelReportAll = withTraceErrorBoundary(PlayerLevelReportAllWithAccess, ErrorModal);
